import { createContext } from "react";

const MobileActionBarContext = createContext(null);

export default MobileActionBarContext;
